import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { MembershipTypeConfiguration } from 'src/features/membershipType/types';

const RESOURCE = 'sp-core/:parkingId/memberships/membership-type/:membershipTypeId/current-configuration/';

type QueryFnType = typeof queryFn;

interface DTO {
    membershipTypeId: string;
    parkingId: string;
}
const queryFn = ({ parkingId, membershipTypeId }: DTO): Promise<MembershipTypeConfiguration> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, membershipTypeId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        staleTime: 1000 * 60 * 10,
        ...config,
    });

export { RESOURCE as MEMBERSHIP_TYPE_CONFIGURATION_RESOURCE, useQueryHook as useGetMembershipTypeConfiguration };
